<script>
export default {
  computed: {
    products() {
      let list = this.$products;

      if (this.filterType === 'value' && this.filterValue) {
        list = this.$getProductsByValue(this.filterValue);
      } else if (this.filterType === 'collection' && this.filterValue) {
        list = this.$getProductsByCollectionId(this.filterValue);
      }
      return this.teaser ? this.teasedProducts : this.$filterByWave(list, this.$currentWave);
    },
    filterValue() {
      return this.$store.state.filters.filterValue;
    },
    currentFilterList() {
      return this.filterType === 'value' ? this.$config.common.search.by_value : this.$config.common.search.by_collection;
    },
    currentFilter() {
      return this.currentFilterList.values.find(value => value.value === this.filterValue);
    },
    rawFilterValues() {
      return this.$config.common.search[`by_${this.filterType}`].values;
    },
    filterValues() {
      // return this.$config.common.search[`by_${this.filterType}`].values;
      return this.orderedFilterValues;
    },
    orderedFilterValues() {
      return this.filterType === 'value' ? this.rawFilterValues : this.rawFilterValues.toSorted((a, b) => b.count - a.count);
    },
    filterType() {
      return this.$store.state.filters.filterType;
    },
  },
  methods: {
    // invoked in App.vue at startup
    countFilterValues() {
      this.$config.common.search.by_collection.values.forEach((value) => {
        // eslint-disable-next-line no-param-reassign
        value.count =
        this.$filterByWave(this.$getProductsByCollectionId(value.value), this.$currentWave)
          .filter(product => product.box !== true)
          .length;
      });
      this.$config.common.search.by_value.values.forEach((value) => {
        // eslint-disable-next-line no-param-reassign
        value.count =
          this.$filterByWave(this.$getProductsByValue(value.value), this.$currentWave)
            .filter(product => product.box !== true)
            .length;
      });
    },
    processPluralString(str, count = 1) {
      const formatter = {
        s: count > 1 ? 's' : '',
        count,
        wordcount: this.$config.common.counts[count] !== undefined ?
          this.$config.common.counts[count] : this.getWordCount(count),
      };
      return str.format(formatter);
    },
    getWordCount(count) {
      return this.$config.common.useWordCounter ? this.$getToWordsInstance().convert(count) : count;
    },
  },
};
</script>
